@file:Suppress(
    "RETURN_VALUE_NOT_USED",
    "RETURN_VALUE_NOT_USED_COERCION",
)

import com.varabyte.kobweb.core.AppGlobals
import com.varabyte.kobweb.navigation.BasePath
import com.varabyte.kobweb.navigation.Router
import com.varabyte.kobweb.navigation.UpdateHistoryMode
import com.varabyte.kobweb.navigation.remove
import com.varabyte.kobweb.silk.defer.DeferringHost
import kotlin.Suppress
import kotlinx.browser.document
import kotlinx.browser.window
import org.jetbrains.compose.web.renderComposable
import io.horion.cv.pages.About as _io_horion_cv_pages_About
import io.horion.cv.pages.Conditions as _io_horion_cv_pages_Conditions
import io.horion.cv.pages.ConfirmPaymentPage as _io_horion_cv_pages_ConfirmPaymentPage
import io.horion.cv.pages.ConfirmationPage as _io_horion_cv_pages_ConfirmationPage
import io.horion.cv.pages.ConnectPage as _io_horion_cv_pages_ConnectPage
import io.horion.cv.pages.Faq as _io_horion_cv_pages_Faq
import io.horion.cv.pages.HomePage as _io_horion_cv_pages_HomePage
import io.horion.cv.pages.PaymentPage as _io_horion_cv_pages_PaymentPage
import io.horion.cv.pages.PaymentProcessingPage as _io_horion_cv_pages_PaymentProcessingPage
import io.horion.cv.pages.PaymentSuccessPage as _io_horion_cv_pages_PaymentSuccessPage
import io.horion.cv.pages.Price as _io_horion_cv_pages_Price
import io.horion.cv.pages.Privacy as _io_horion_cv_pages_Privacy
import io.horion.cv.pages.RegisterInfo as _io_horion_cv_pages_RegisterInfo
import io.horion.cv.pages.RegisterPassword as _io_horion_cv_pages_RegisterPassword
import io.horion.cv.pages.cv.ChooseCvPage as _io_horion_cv_pages_cv_ChooseCvPage
import io.horion.cv.pages.cv.Cv as _io_horion_cv_pages_cv_Cv
import io.horion.cv.pages.cv.CvPreviewPage as _io_horion_cv_pages_cv_CvPreviewPage
import io.horion.cv.pages.cv.DomaineActivity as _io_horion_cv_pages_cv_DomaineActivity
import io.horion.cv.pages.cv.InfoPage as _io_horion_cv_pages_cv_InfoPage
import io.horion.cv.pages.cv.ModelCvPage as _io_horion_cv_pages_cv_ModelCvPage
import io.horion.cv.pages.cv.OrientationCvPage as _io_horion_cv_pages_cv_OrientationCvPage
import io.horion.cv.pages.dashboard.CandidaturesPage as _io_horion_cv_pages_dashboard_CandidaturesPage
import io.horion.cv.pages.dashboard.CurriculumVitaePage as _io_horion_cv_pages_dashboard_CurriculumVitaePage
import io.horion.cv.pages.dashboard.DashboardPage as _io_horion_cv_pages_dashboard_DashboardPage
import io.horion.cv.pages.dashboard.LettresDeMotivationPage as _io_horion_cv_pages_dashboard_LettresDeMotivationPage
import io.horion.cv.pages.dashboard.OffresEmploisPage as _io_horion_cv_pages_dashboard_OffresEmploisPage
import io.horion.cv.pages.dashboard.UpdateCvPage as _io_horion_cv_pages_dashboard_UpdateCvPage
import io.horion.cv.pages.dashboard.UpdateLetterPage as _io_horion_cv_pages_dashboard_UpdateLetterPage
import io.horion.cv.pages.job.company.Candidature as _io_horion_cv_pages_job_company_Candidature
import io.horion.cv.pages.job.company.Create as _io_horion_cv_pages_job_company_Create
import io.horion.cv.pages.job.company.JobListePage as _io_horion_cv_pages_job_company_JobListePage
import io.horion.cv.pages.job.company.UpdateJob as _io_horion_cv_pages_job_company_UpdateJob
import io.horion.cv.pages.job.user.ConsulterJob as _io_horion_cv_pages_job_user_ConsulterJob
import io.horion.cv.pages.job.user.JobPage as _io_horion_cv_pages_job_user_JobPage
import io.horion.cv.pages.motivation.InfoLetterPage as _io_horion_cv_pages_motivation_InfoLetterPage
import io.horion.cv.pages.motivation.LetterPreviewPage as _io_horion_cv_pages_motivation_LetterPreviewPage
import io.horion.cv.pages.motivation.ListLetter as _io_horion_cv_pages_motivation_ListLetter
import io.horion.cv.pages.motivation.Motivation as _io_horion_cv_pages_motivation_Motivation

public fun main() {
    AppGlobals.initialize(mapOf("title" to "Cv"))
    BasePath.set("")
    val router = Router()
    com.varabyte.kobweb.core.init.initKobweb(router) { ctx ->
        ctx.router.register(
            "/",
        ) { pageCtx -> 
            _io_horion_cv_pages_HomePage()
        }
        ctx.router.register(
            "/about",
        ) { pageCtx -> 
            _io_horion_cv_pages_About()
        }
        ctx.router.register(
            "/choose-cv",
        ) { pageCtx -> 
            _io_horion_cv_pages_cv_ChooseCvPage()
        }
        ctx.router.register(
            "/conditions",
        ) { pageCtx -> 
            _io_horion_cv_pages_Conditions()
        }
        ctx.router.register(
            "/confirm-payment",
        ) { pageCtx -> 
            _io_horion_cv_pages_ConfirmPaymentPage()
        }
        ctx.router.register(
            "/confirmation",
        ) { pageCtx -> 
            _io_horion_cv_pages_ConfirmationPage()
        }
        ctx.router.register(
            "/connexion",
        ) { pageCtx -> 
            _io_horion_cv_pages_ConnectPage()
        }
        ctx.router.register(
            "/creer_un_cv",
        ) { pageCtx -> 
            _io_horion_cv_pages_cv_OrientationCvPage()
        }
        ctx.router.register(
            "/cv/cv",
        ) { pageCtx -> 
            _io_horion_cv_pages_cv_Cv()
        }
        ctx.router.register(
            "/cv_preview",
        ) { pageCtx -> 
            _io_horion_cv_pages_cv_CvPreviewPage()
        }
        ctx.router.register(
            "/dashboard/Lettres",
        ) { pageCtx -> 
            _io_horion_cv_pages_dashboard_LettresDeMotivationPage()
        }
        ctx.router.register(
            "/dashboard/candidatures",
        ) { pageCtx -> 
            _io_horion_cv_pages_dashboard_CandidaturesPage()
        }
        ctx.router.register(
            "/dashboard/cv",
        ) { pageCtx -> 
            _io_horion_cv_pages_dashboard_CurriculumVitaePage()
        }
        ctx.router.register(
            "/dashboard/emploi",
        ) { pageCtx -> 
            _io_horion_cv_pages_dashboard_OffresEmploisPage()
        }
        ctx.router.register(
            "/dashboard/tableau-de-bord",
        ) { pageCtx -> 
            _io_horion_cv_pages_dashboard_DashboardPage()
        }
        ctx.router.register(
            "/dashboard/update-cv",
        ) { pageCtx -> 
            _io_horion_cv_pages_dashboard_UpdateCvPage()
        }
        ctx.router.register(
            "/dashboard/update-letter",
        ) { pageCtx -> 
            _io_horion_cv_pages_dashboard_UpdateLetterPage()
        }
        ctx.router.register(
            "/domaine",
        ) { pageCtx -> 
            _io_horion_cv_pages_cv_DomaineActivity()
        }
        ctx.router.register(
            "/faq",
        ) { pageCtx -> 
            _io_horion_cv_pages_Faq()
        }
        ctx.router.register(
            "/info_letter_page",
        ) { pageCtx -> 
            _io_horion_cv_pages_motivation_InfoLetterPage()
        }
        ctx.router.register(
            "/info_pers",
        ) { pageCtx -> 
            _io_horion_cv_pages_cv_InfoPage()
        }
        ctx.router.register(
            "/inscription",
        ) { pageCtx -> 
            _io_horion_cv_pages_RegisterInfo()
        }
        ctx.router.register(
            "/job",
        ) { pageCtx -> 
            _io_horion_cv_pages_job_user_JobPage()
        }
        ctx.router.register(
            "/job/candidatures",
        ) { pageCtx -> 
            _io_horion_cv_pages_job_company_Candidature()
        }
        ctx.router.register(
            "/job/consulter",
        ) { pageCtx -> 
            _io_horion_cv_pages_job_user_ConsulterJob()
        }
        ctx.router.register(
            "/job/create",
        ) { pageCtx -> 
            _io_horion_cv_pages_job_company_Create()
        }
        ctx.router.register(
            "/job/recruteur",
        ) { pageCtx -> 
            _io_horion_cv_pages_job_company_JobListePage()
        }
        ctx.router.register(
            "/job/update",
        ) { pageCtx -> 
            _io_horion_cv_pages_job_company_UpdateJob()
        }
        ctx.router.register(
            "/letterpreview",
        ) { pageCtx -> 
            _io_horion_cv_pages_motivation_LetterPreviewPage()
        }
        ctx.router.register(
            "/listletter",
        ) { pageCtx -> 
            _io_horion_cv_pages_motivation_ListLetter()
        }
        ctx.router.register(
            "/modeles-cv/{model}",
        ) { pageCtx -> 
            _io_horion_cv_pages_cv_ModelCvPage()
        }
        ctx.router.register(
            "/motivation",
        ) { pageCtx -> 
            _io_horion_cv_pages_motivation_Motivation()
        }
        ctx.router.register(
            "/payment",
        ) { pageCtx -> 
            _io_horion_cv_pages_PaymentPage()
        }
        ctx.router.register(
            "/payment-processing",
        ) { pageCtx -> 
            _io_horion_cv_pages_PaymentProcessingPage()
        }
        ctx.router.register(
            "/payment-success",
        ) { pageCtx -> 
            _io_horion_cv_pages_PaymentSuccessPage()
        }
        ctx.router.register(
            "/price",
        ) { pageCtx -> 
            _io_horion_cv_pages_Price()
        }
        ctx.router.register(
            "/privacy",
        ) { pageCtx -> 
            _io_horion_cv_pages_Privacy()
        }
        ctx.router.register(
            "/validation",
        ) { pageCtx -> 
            _io_horion_cv_pages_RegisterPassword()
        }

    }
    router.addRouteInterceptor {
        path = path.removeSuffix(".html").removeSuffix(".htm")
    }

    com.varabyte.kobweb.silk.init.additionalSilkInitialization = { ctx ->
        com.varabyte.kobweb.silk.init.initSilkWidgets(ctx)
        com.varabyte.kobweb.silk.init.initSilkWidgetsKobweb(ctx)
        ctx.theme.registerStyle("periode-label", io.horion.cv.styles.PeriodeLabelStyle)
        ctx.theme.registerStyle("checkbox-label", io.horion.cv.styles.CheckboxLabelStyle)
        ctx.theme.registerStyle("dropdown-select", io.horion.cv.styles.DropdownSelectStyle)
        ctx.theme.registerStyle("separator", io.horion.cv.styles.SeparatorStyle)
        ctx.theme.registerStyle("download-cv-button", io.horion.cv.styles.DownloadCvButtonStyle)
        ctx.theme.registerStyle("signature-form", io.horion.cv.styles.SignatureFormStyle)
        ctx.theme.registerStyle("signature-fields-container", io.horion.cv.styles.SignatureFieldsContainerStyle)
        ctx.theme.registerStyle("signature-field-input", io.horion.cv.styles.SignatureFieldInputStyle)
        ctx.theme.registerStyle("signature-date-input", io.horion.cv.styles.SignatureDateInputStyle)
        ctx.theme.registerStyle("signature-label", io.horion.cv.styles.SignatureLabelStyle)
        ctx.theme.registerStyle("signature-box", io.horion.cv.styles.SignatureBoxStyle)
        ctx.theme.registerStyle("signature-placeholder-icon", io.horion.cv.styles.SignaturePlaceholderIconStyle)
        ctx.theme.registerStyle("signature-modal-container", io.horion.cv.styles.SignatureModalContainerStyle)
        ctx.theme.registerStyle("signature-modal-title", io.horion.cv.styles.SignatureModalTitleStyle)
        ctx.theme.registerStyle("signature-close-button", io.horion.cv.styles.SignatureCloseButtonStyle)
        ctx.theme.registerStyle("signature-close-icon", io.horion.cv.styles.SignatureCloseIconStyle)
        ctx.theme.registerStyle("signature-modal-first-spacer", io.horion.cv.styles.SignatureModalFirstSpacerStyle)
        ctx.theme.registerStyle("signature-modal-second-spacer", io.horion.cv.styles.SignatureModalSecondSpacerStyle)
        ctx.theme.registerStyle("signature-actions-row", io.horion.cv.styles.SignatureActionsRowStyle)
        ctx.theme.registerStyle("signature-actions-group", io.horion.cv.styles.SignatureActionsGroupStyle)
        ctx.theme.registerStyle("signature-color-group", io.horion.cv.styles.SignatureColorGroupStyle)
        ctx.theme.registerStyle("erase-button", io.horion.cv.styles.EraseButtonStyle)
        ctx.theme.registerStyle("erase-icon", io.horion.cv.styles.EraseIconStyle)
        ctx.theme.registerStyle("erase-text", io.horion.cv.styles.EraseTextStyle)
        ctx.theme.registerStyle("finish-button", io.horion.cv.styles.FinishButtonStyle)
        ctx.theme.registerStyle("finish-button-text", io.horion.cv.styles.FinishButtonTextStyle)
        ctx.theme.registerStyle("signature-tab-text", io.horion.cv.styles.SignatureTabTextStyle)
        ctx.theme.registerStyle("drawing-canvas", io.horion.cv.styles.DrawingCanvasStyle)
        ctx.theme.registerStyle("font-selector-button", io.horion.cv.styles.FontSelectorButtonStyle)
        ctx.theme.registerStyle("font-selector-text", io.horion.cv.styles.FontSelectorTextStyle)
        ctx.theme.registerStyle("font-selector-arrow", io.horion.cv.styles.FontSelectorArrowStyle)
        ctx.theme.registerStyle("color-dot", io.horion.cv.styles.ColorDotStyle)
        ctx.theme.registerStyle("color-dot-check-icon", io.horion.cv.styles.ColorDotCheckIconStyle)
        ctx.theme.registerStyle("signature-fields-mobile", io.horion.cv.styles.SignatureFieldsMobileStyle)
        ctx.theme.registerStyle("signature-fields-desktop", io.horion.cv.styles.SignatureFieldsDesktopStyle)
        ctx.theme.registerStyle("signature-actions-spacing", io.horion.cv.styles.SignatureActionsSpacingStyle)
        ctx.theme.registerStyle("signature-colors-spacing", io.horion.cv.styles.SignatureColorsSpacingStyle)
        ctx.theme.registerStyle("erase-content-spacing", io.horion.cv.styles.EraseContentSpacingStyle)
        ctx.theme.registerStyle("font-selector-spacing", io.horion.cv.styles.FontSelectorSpacingStyle)
        ctx.theme.registerStyle("profile-description", io.horion.cv.styles.ProfileDescriptionStyle)
        ctx.theme.registerStyle("lettre-carousel-container", io.horion.cv.styles.LettreCarouselContainerStyle)
        ctx.theme.registerStyle("lettre-carousel-track", io.horion.cv.styles.LettreCarouselTrackStyle)
        ctx.theme.registerStyle("lettre-carousel-viewport", io.horion.cv.styles.LettreCarouselViewportStyle)
        ctx.theme.registerStyle("cover-letter-card", io.horion.cv.styles.CoverLetterCardStyle)
        ctx.theme.registerStyle("chevron-button-icon", io.horion.cv.styles.ChevronButtonIconStyle)
        ctx.theme.registerStyle("cover-letter-button-text", io.horion.cv.styles.CoverLetterButtonTextStyle)
        ctx.theme.registerStyle("cover-letter-card-button", io.horion.cv.styles.CoverLetterCardButtonStyle)
        ctx.theme.registerStyle("cover-letter-card-container", io.horion.cv.styles.CoverLetterCardContainerStyle)
        ctx.theme.registerStyle("add-button", io.horion.cv.styles.AddButtonStyle)
        ctx.theme.registerStyle("add-button-icon", io.horion.cv.styles.AddButtonIconStyle)
        ctx.theme.registerStyle("add-button-text", io.horion.cv.styles.AddButtonTextStyle)
        ctx.theme.registerStyle("date-range-container", io.horion.cv.styles.DateRangeContainerStyle)
        ctx.theme.registerStyle("date-section", io.horion.cv.styles.DateSectionStyle)
        ctx.theme.registerStyle("date-label", io.horion.cv.styles.DateLabelStyle)
        ctx.theme.registerStyle("processing-container", io.horion.cv.styles.ProcessingContainerStyle)
        ctx.theme.registerStyle("processing-title", io.horion.cv.styles.ProcessingTitleStyle)
        ctx.theme.registerStyle("processing-steps-list", io.horion.cv.styles.ProcessingStepsListStyle)
        ctx.theme.registerStyle("processing-step-badge", io.horion.cv.styles.ProcessingStepBadgeStyle)
        ctx.theme.registerStyle("processing-step-number", io.horion.cv.styles.ProcessingStepNumberStyle)
        ctx.theme.registerStyle("processing-step-text", io.horion.cv.styles.ProcessingStepTextStyle)
        ctx.theme.registerStyle("motivation-section", io.horion.cv.styles.MotivationSectionStyle)
        ctx.theme.registerStyle("motivation-title", io.horion.cv.styles.MotivationTitleStyle)
        ctx.theme.registerStyle("motivation-subtitle", io.horion.cv.styles.MotivationSubtitleStyle)
        ctx.theme.registerStyle("letter-row", io.horion.cv.styles.LetterRowStyle)
        ctx.theme.registerStyle("letter-carousel-wrapper", io.horion.cv.styles.LetterCarouselWrapperStyle)
        ctx.theme.registerStyle("view-more-button", io.horion.cv.styles.ViewMoreButtonStyle)
        ctx.theme.registerStyle("view-more-arrow", io.horion.cv.styles.ViewMoreArrowStyle)
        ctx.theme.registerStyle("footer-mobile-section", io.horion.cv.styles.FooterMobileSectionStyle)
        ctx.theme.registerStyle("footer-desktop-section", io.horion.cv.styles.FooterDesktopSectionStyle)
        ctx.theme.registerStyle("footer-main-container", io.horion.cv.styles.FooterMainContainerStyle)
        ctx.theme.registerStyle("footer-brand-container", io.horion.cv.styles.FooterBrandContainerStyle)
        ctx.theme.registerStyle("footer-brand-logo", io.horion.cv.styles.FooterBrandLogoStyle)
        ctx.theme.registerStyle("footer-brand-text", io.horion.cv.styles.FooterBrandTextStyle)
        ctx.theme.registerStyle("footer-link-column", io.horion.cv.styles.FooterLinkColumnStyle)
        ctx.theme.registerStyle("footer-divider", io.horion.cv.styles.FooterDividerStyle)
        ctx.theme.registerStyle("footer-copyright", io.horion.cv.styles.FooterCopyrightStyle)
        ctx.theme.registerStyle("model-view-button-margin", io.horion.cv.styles.ModelViewButtonMarginStyle)
        ctx.theme.registerStyle("view-button-responsive", io.horion.cv.styles.ViewButtonResponsiveStyle)
        ctx.theme.registerStyle("view-button-modal", io.horion.cv.styles.ViewButtonModalStyle)
        ctx.theme.registerStyle("mobile-carousel-container", io.horion.cv.styles.MobileCarouselContainerStyle)
        ctx.theme.registerStyle("desktop-carousel-container", io.horion.cv.styles.DesktopCarouselContainerStyle)
        ctx.theme.registerStyle("chevron-button-left-position", io.horion.cv.styles.ChevronButtonLeftPositionStyle)
        ctx.theme.registerStyle("chevron-button-right-position", io.horion.cv.styles.ChevronButtonRightPositionStyle)
        ctx.theme.registerStyle("view-button-label-short", io.horion.cv.styles.ViewButtonLabelShortStyle)
        ctx.theme.registerStyle("view-button-label-long", io.horion.cv.styles.ViewButtonLabelLongStyle)
        ctx.theme.registerStyle("view-button-base", io.horion.cv.styles.ViewButtonBaseStyle)
        ctx.theme.registerStyle("hero-overlay", io.horion.cv.styles.HeroOverlayStyle)
        ctx.theme.registerStyle("motive-button-label-short", io.horion.cv.styles.MotiveButtonLabelShortStyle)
        ctx.theme.registerStyle("motive-button-label-long", io.horion.cv.styles.MotiveButtonLabelLongStyle)
        ctx.theme.registerStyle("cover-button-hero-radius", io.horion.cv.styles.CoverButtonHeroRadiusStyle)
        ctx.theme.registerStyle("view-more-button-arrow", io.horion.cv.styles.ViewMoreButtonArrowStyle)
        ctx.theme.registerStyle("view-more-label-short", io.horion.cv.styles.ViewMoreLabelShortStyle)
        ctx.theme.registerStyle("view-more-label-long", io.horion.cv.styles.ViewMoreLabelLongStyle)
        ctx.theme.registerStyle("country-title-mobile-text", io.horion.cv.styles.CountryTitleMobileTextStyle)
        ctx.theme.registerStyle("country-title-desktop-text", io.horion.cv.styles.CountryTitleDesktopTextStyle)
        ctx.theme.registerStyle("country-button-label-short", io.horion.cv.styles.CountryButtonLabelShortStyle)
        ctx.theme.registerStyle("country-button-label-long", io.horion.cv.styles.CountryButtonLabelLongStyle)
        ctx.theme.registerStyle("country-card-container", io.horion.cv.styles.CountryCardContainerStyle)
        ctx.theme.registerStyle("country-card-circle", io.horion.cv.styles.CountryCardCircleStyle)
        ctx.theme.registerStyle("country-card-image", io.horion.cv.styles.CountryCardImageStyle)
        ctx.theme.registerStyle("country-card-text", io.horion.cv.styles.CountryCardTextStyle)
        ctx.theme.registerStyle("testimonial-card-container", io.horion.cv.styles.TestimonialCardContainerStyle)
        ctx.theme.registerStyle("testimonial-card-image", io.horion.cv.styles.TestimonialCardImageStyle)
        ctx.theme.registerStyle("testimonial-card-comment", io.horion.cv.styles.TestimonialCardCommentStyle)
        ctx.theme.registerStyle("testimonial-card-star", io.horion.cv.styles.TestimonialCardStarStyle)
        ctx.theme.registerStyle("testimonial-card-name", io.horion.cv.styles.TestimonialCardNameStyle)
        ctx.theme.registerStyle("testimonial-card-job", io.horion.cv.styles.TestimonialCardJobStyle)
        ctx.theme.registerStyle("testimonial-mobile-container", io.horion.cv.styles.TestimonialMobileContainerStyle)
        ctx.theme.registerStyle("testimonial-desktop-container", io.horion.cv.styles.TestimonialDesktopContainerStyle)
        ctx.theme.registerStyle("testimonial-desktop-row", io.horion.cv.styles.TestimonialDesktopRowStyle)
        ctx.theme.registerStyle("linear-gradient", io.horion.cv.styles.LinearGradientStyle)
        ctx.theme.registerStyle("model-image", io.horion.cv.styles.ModelImageStyle)
        ctx.theme.registerStyle("choose-model", io.horion.cv.styles.ChooseModelStyle)
        ctx.theme.registerStyle("model-cv", io.horion.cv.styles.ModelCvStyle)
        ctx.theme.registerStyle("accordion-row", io.horion.cv.styles.AccordionRowStyle)
        ctx.theme.registerStyle("model-section", io.horion.cv.styles.ModelSectionStyle)
        ctx.theme.registerStyle("model-section-title", io.horion.cv.styles.ModelSectionTitleStyle)
        ctx.theme.registerStyle("view-button-wrapper", io.horion.cv.styles.ViewButtonWrapperStyle)
        ctx.theme.registerStyle("carousel-wrapper", io.horion.cv.styles.CarouselWrapperStyle)
        ctx.theme.registerStyle("meatball-container", io.horion.cv.styles.MeatballContainerStyle)
        ctx.theme.registerStyle("chevron-button", io.horion.cv.styles.ChevronButtonStyle)
        ctx.theme.registerStyle("chevron-image", io.horion.cv.styles.ChevronImageStyle)
        ctx.theme.registerStyle("chevron-left-position", io.horion.cv.styles.ChevronLeftPositionStyle)
        ctx.theme.registerStyle("chevron-right-position", io.horion.cv.styles.ChevronRightPositionStyle)
        ctx.theme.registerStyle("meatball-row", io.horion.cv.styles.MeatballRowStyle)
        ctx.theme.registerStyle("meatball-dot", io.horion.cv.styles.MeatballDotStyle)
        ctx.theme.registerStyle("view-button-stylecss", io.horion.cv.styles.ViewButtonStylecss)
        ctx.theme.registerStyle("view-button-arrow", io.horion.cv.styles.ViewButtonArrowStyle)
        ctx.theme.registerStyle("candidatures-text", io.horion.cv.styles.CandidaturesTextStyle)
        ctx.theme.registerStyle("create-document-card-text", io.horion.cv.styles.CreateDocumentCardTextStyle)
        ctx.theme.registerStyle("span-text-stylecss", io.horion.cv.styles.SpanTextStylecss)
        ctx.theme.registerStyle("text-style-css", io.horion.cv.styles.TextStyleCss)
        ctx.theme.registerStyle("span-style-css", io.horion.cv.styles.SpanStyleCSS)
        ctx.theme.registerStyle("create-card-stylecss", io.horion.cv.styles.CreateCardStylecss)
        ctx.theme.registerStyle("create-card-spantext-stylecss", io.horion.cv.styles.CreateCardSpantextStylecss)
        ctx.theme.registerStyle("search-button-responsive", io.horion.cv.styles.SearchButtonResponsiveStyle)
        ctx.theme.registerStyle("dashboard-content", io.horion.cv.styles.DashboardContentStyle)
        ctx.theme.registerStyle("dashboard-main-content", io.horion.cv.styles.DashboardMainContentStyle)
        ctx.theme.registerStyle("dashboard-grid", io.horion.cv.styles.DashboardGridStyle)
        ctx.theme.registerStyle("desktop-only", io.horion.cv.styles.DesktopOnlyStyle)
        ctx.theme.registerStyle("mobile-only", io.horion.cv.styles.MobileOnlyStyle)
        ctx.theme.registerStyle("search-form", io.horion.cv.styles.SearchFormStyle)
        ctx.theme.registerStyle("search-field-wrapper", io.horion.cv.styles.SearchFieldWrapperStyle)
        ctx.theme.registerStyle("info-box", io.horion.cv.styles.InfoBoxStyle)
        ctx.theme.registerStyle("info-box-icon", io.horion.cv.styles.InfoBoxIconStyle)
        ctx.theme.registerStyle("info-box-text", io.horion.cv.styles.InfoBoxTextStyle)
        ctx.theme.registerStyle("choose-cv-mobile-container", io.horion.cv.styles.ChooseCvMobileContainerStyle)
        ctx.theme.registerStyle("choose-cv-desktop-container", io.horion.cv.styles.ChooseCvDesktopContainerStyle)
        ctx.theme.registerStyle("choose-cv-title", io.horion.cv.styles.ChooseCvTitleStyle)
        ctx.theme.registerStyle("choose-cv-subtitle", io.horion.cv.styles.ChooseCvSubtitleStyle)
        ctx.theme.registerStyle("cv-card-box", io.horion.cv.styles.CvCardBoxStyle)
        ctx.theme.registerStyle("header-padding", io.horion.cv.styles.HeaderPaddingStyle)
        ctx.theme.registerStyle("header-home-margin", io.horion.cv.styles.HeaderHomeMarginStyle)
        ctx.theme.registerStyle("header-home-icon", io.horion.cv.styles.HeaderHomeIconStyle)
        ctx.theme.registerStyle("header-home-text", io.horion.cv.styles.HeaderHomeTextStyle)
        ctx.theme.registerStyle("header-title-container", io.horion.cv.styles.HeaderTitleContainerStyle)
        ctx.theme.registerStyle("header-title-text", io.horion.cv.styles.HeaderTitleTextStyle)
        ctx.theme.registerStyle("header-title-icon", io.horion.cv.styles.HeaderTitleIconStyle)
        ctx.theme.registerStyle("header-theme-container", io.horion.cv.styles.HeaderThemeContainerStyle)
        ctx.theme.registerStyle("header-theme-icon", io.horion.cv.styles.HeaderThemeIconStyle)
        ctx.theme.registerStyle("logo", io.horion.cv.styles.LogoStyle)
        ctx.theme.registerStyle("navigation-item", io.horion.cv.styles.NavigationItemStyle)
        ctx.theme.registerStyle("alignment-option", io.horion.cv.styles.AlignmentOptionStyle)
        ctx.theme.registerStyle("button", io.horion.cv.styles.ButtonStyle)
        ctx.theme.registerStyle("create-button", io.horion.cv.styles.CreateButtonStyle)
        ctx.theme.registerStyle("connect-button", io.horion.cv.styles.ConnectButtonStyle)
        ctx.theme.registerStyle("connect", io.horion.cv.styles.connectStyle)
        ctx.theme.registerStyle("profile-form", io.horion.cv.styles.ProfileFormStyle)
        ctx.theme.registerStyle("rich-text-label", io.horion.cv.styles.RichTextLabelStyle)
        ctx.theme.registerStyle("google", io.horion.cv.styles.GoogleStyle)
        ctx.theme.registerStyle("apple", io.horion.cv.styles.AppleStyle)
        ctx.theme.registerStyle("global-background", io.horion.cv.styles.GlobalBackgroundStyle)
        ctx.theme.registerStyle("modify-button", io.horion.cv.styles.ModifyButtonStyle)
        ctx.theme.registerStyle("download-button", io.horion.cv.styles.DownloadButtonStyle)
        ctx.theme.registerStyle("police", io.horion.cv.styles.PoliceStyle)
        ctx.theme.registerStyle("search-button", io.horion.cv.styles.SearchButtonStyle)
        ctx.theme.registerStyle("delete", io.horion.cv.styles.DeleteStyle)
        ctx.theme.registerStyle("subscribe-button", io.horion.cv.styles.SubscribeButtonStyle)
        ctx.theme.registerStyle("validatebutton", io.horion.cv.styles.validatebuttonStyle)
        ctx.theme.registerStyle("hero-container", io.horion.cv.styles.HeroContainerStyle)
        ctx.theme.registerStyle("hero-content-box", io.horion.cv.styles.HeroContentBoxStyle)
        ctx.theme.registerStyle("hero-content-column", io.horion.cv.styles.HeroContentColumnStyle)
        ctx.theme.registerStyle("hero-title", io.horion.cv.styles.HeroTitleStyle)
        ctx.theme.registerStyle("hero-subtitle", io.horion.cv.styles.HeroSubtitleStyle)
        ctx.theme.registerStyle("responsive-button", io.horion.cv.styles.ResponsiveButtonStyle)
        ctx.theme.registerStyle("span-text", io.horion.cv.styles.SpanTextStyle)
        ctx.theme.registerStyle("payment-container", io.horion.cv.styles.PaymentContainerStyle)
        ctx.theme.registerStyle("payment-header-row", io.horion.cv.styles.PaymentHeaderRowStyle)
        ctx.theme.registerStyle("payment-back-icon", io.horion.cv.styles.PaymentBackIconStyle)
        ctx.theme.registerStyle("payment-title", io.horion.cv.styles.PaymentTitleStyle)
        ctx.theme.registerStyle("payment-content-wrapper", io.horion.cv.styles.PaymentContentWrapperStyle)
        ctx.theme.registerStyle("payment-form-section", io.horion.cv.styles.PaymentFormSectionStyle)
        ctx.theme.registerStyle("payment-operator-label", io.horion.cv.styles.PaymentOperatorLabelStyle)
        ctx.theme.registerStyle("payment-operators-row", io.horion.cv.styles.PaymentOperatorsRowStyle)
        ctx.theme.registerStyle("payment-phone-label", io.horion.cv.styles.PaymentPhoneLabelStyle)
        ctx.theme.registerStyle("payment-form-button", io.horion.cv.styles.PaymentFormButtonStyle)
        ctx.theme.registerStyle("payment-card-container", io.horion.cv.styles.PaymentCardContainerStyle)
        ctx.theme.registerStyle("payment-card-inner-row", io.horion.cv.styles.PaymentCardInnerRowStyle)
        ctx.theme.registerStyle("payment-card-dot-indicator", io.horion.cv.styles.PaymentCardDotIndicatorStyle)
        ctx.theme.registerStyle("orange-image", io.horion.cv.styles.OrangeImageStyle)
        ctx.theme.registerStyle("mtn-image", io.horion.cv.styles.MtnImageStyle)
        ctx.theme.registerStyle("price-summary-card", io.horion.cv.styles.PriceSummaryCardStyle)
        ctx.theme.registerStyle("price-summary-row", io.horion.cv.styles.PriceSummaryRowStyle)
        ctx.theme.registerStyle("price-summary-amount-text", io.horion.cv.styles.PriceSummaryAmountTextStyle)
        ctx.theme.registerStyle("price-summary-subtext", io.horion.cv.styles.PriceSummarySubtextStyle)
        ctx.theme.registerStyle("price-summary-features-container", io.horion.cv.styles.PriceSummaryFeaturesContainerStyle)
        ctx.theme.registerStyle("incompatibility-popup-overlay", io.horion.cv.styles.IncompatibilityPopupOverlayStyle)
        ctx.theme.registerStyle("incompatibility-popup-card", io.horion.cv.styles.IncompatibilityPopupCardStyle)
        ctx.theme.registerStyle("incompatibility-popup-emoji", io.horion.cv.styles.IncompatibilityPopupEmojiStyle)
        ctx.theme.registerStyle("incompatibility-popup-title", io.horion.cv.styles.IncompatibilityPopupTitleStyle)
        ctx.theme.registerStyle("incompatibility-popup-text", io.horion.cv.styles.IncompatibilityPopupTextStyle)
        ctx.theme.registerStyle("incompatibility-popup-button-text", io.horion.cv.styles.IncompatibilityPopupButtonTextStyle)
        ctx.theme.registerStyle("realisation-description", io.horion.cv.styles.RealisationDescriptionStyle)
        ctx.theme.registerStyle("cover-job", io.horion.cv.styles.CoverJobStyle)
        ctx.theme.registerStyle("interactive-element", io.horion.cv.styles.InteractiveElementStyle)
        ctx.theme.registerStyle("formlocalisation", io.horion.cv.styles.FormlocalisationStyle)
        ctx.theme.registerStyle("text-form-field-white", io.horion.cv.styles.TextFormFieldWhiteStyle)
        ctx.theme.registerStyle("select-form-input", io.horion.cv.styles.SelectFormInputStyle)
        ctx.theme.registerStyle("text-description-form", io.horion.cv.styles.TextDescriptionFormStyle)
        ctx.theme.registerStyle("form-action-grid-container", io.horion.cv.styles.FormActionGridContainerStyle)
        ctx.theme.registerStyle("form-action-submit-row", io.horion.cv.styles.FormActionSubmitRowStyle)
        ctx.theme.registerStyle("form-action-button", io.horion.cv.styles.FormActionButtonStyle)
        ctx.theme.registerStyle("download-button-compact", io.horion.cv.styles.DownloadButtonCompactStyle)
        ctx.theme.registerStyle("download-button-icon-gap", io.horion.cv.styles.DownloadButtonIconGapStyle)
        ctx.theme.registerStyle("validation-popup-container", io.horion.cv.styles.ValidationPopupContainerStyle)
        ctx.theme.registerStyle("validation-popup-header-gap", io.horion.cv.styles.ValidationPopupHeaderGapStyle)
        ctx.theme.registerStyle("validation-popup-icon-box", io.horion.cv.styles.ValidationPopupIconBoxStyle)
        ctx.theme.registerStyle("validation-popup-icon", io.horion.cv.styles.ValidationPopupIconStyle)
        ctx.theme.registerStyle("validation-popup-title-text", io.horion.cv.styles.ValidationPopupTitleTextStyle)
        ctx.theme.registerStyle("view-button", io.horion.cv.styles.ViewButtonStyle)
        ctx.theme.registerStyle("download-button-mobile", io.horion.cv.styles.DownloadButtonMobileStyle)
        ctx.theme.registerStyle("download-button-desktop", io.horion.cv.styles.DownloadButtonDesktopStyle)
        ctx.theme.registerStyle("download-button-mobile-wrapper", io.horion.cv.styles.DownloadButtonMobileWrapperStyle)
        ctx.theme.registerStyle("download-button-desktop-wrapper", io.horion.cv.styles.DownloadButtonDesktopWrapperStyle)
        ctx.theme.registerStyle("blue-gradient-text", io.horion.cv.styles.BlueGradientTextStyle)
        ctx.theme.registerStyle("my", io.horion.cv.styles.MyStyle)
        ctx.theme.registerStyle("procedure-image", io.horion.cv.styles.ProcedureImageStyle)
        ctx.theme.registerStyle("create-card", io.horion.cv.styles.CreateCardStyle)
        ctx.theme.registerStyle("newbutton", io.horion.cv.styles.newbuttonStyle)
        ctx.theme.registerStyle("procedure-section", io.horion.cv.styles.ProcedureSectionStyle)
        ctx.theme.registerStyle("procedure-title", io.horion.cv.styles.ProcedureTitleStyle)
        ctx.theme.registerStyle("procedure-title-container", io.horion.cv.styles.ProcedureTitleContainerStyle)
        ctx.theme.registerStyle("procedure-spacer", io.horion.cv.styles.ProcedureSpacerStyle)
        ctx.theme.registerStyle("step-card", io.horion.cv.styles.StepCardStyle)
        ctx.theme.registerStyle("step-text", io.horion.cv.styles.StepTextStyle)
        ctx.theme.registerStyle("step-number", io.horion.cv.styles.StepNumberStyle)
        ctx.theme.registerStyle("images-preview-section", io.horion.cv.styles.ImagesPreviewSectionStyle)
        ctx.theme.registerStyle("procedure-arrow", io.horion.cv.styles.ProcedureArrowStyle)
        ctx.theme.registerStyle("step-badge", io.horion.cv.styles.StepBadgeStyle)
        ctx.theme.registerStyle("personalized-section-button", io.horion.cv.styles.PersonalizedSectionButtonStyle)
        ctx.theme.registerStyle("personalized-section-icon", io.horion.cv.styles.PersonalizedSectionIconStyle)
        ctx.theme.registerStyle("personalized-section-text", io.horion.cv.styles.PersonalizedSectionTextStyle)
        ctx.theme.registerStyle("personalized-section-chevron", io.horion.cv.styles.PersonalizedSectionChevronStyle)
        ctx.theme.registerStyle("dropdown-item-text", io.horion.cv.styles.DropdownItemTextStyle)
        ctx.theme.registerStyle("price-section-container", io.horion.cv.styles.PriceSectionContainerStyle)
        ctx.theme.registerStyle("price-title", io.horion.cv.styles.PriceTitleStyle)
        ctx.theme.registerStyle("pricing-card-container", io.horion.cv.styles.PricingCardContainerStyle)
        ctx.theme.registerStyle("billing-info", io.horion.cv.styles.BillingInfoStyle)
        ctx.theme.registerStyle("price-row", io.horion.cv.styles.PriceRowStyle)
        ctx.theme.registerStyle("price-text", io.horion.cv.styles.PriceTextStyle)
        ctx.theme.registerStyle("price-subtext", io.horion.cv.styles.PriceSubtextStyle)
        ctx.theme.registerStyle("pricing-button", io.horion.cv.styles.PricingButtonStyle)
        ctx.theme.registerStyle("feature-icon", io.horion.cv.styles.FeatureIconStyle)
        ctx.theme.registerStyle("feature-text", io.horion.cv.styles.FeatureTextStyle)
        ctx.theme.registerStyle("personal-form-main-column", io.horion.cv.styles.PersonalFormMainColumnStyle)
        ctx.theme.registerStyle("personal-form-group-column", io.horion.cv.styles.PersonalFormGroupColumnStyle)
        ctx.theme.registerStyle("personal-form-row", io.horion.cv.styles.PersonalFormRowStyle)
        ctx.theme.registerStyle("personal-form-half-width", io.horion.cv.styles.PersonalFormHalfWidthStyle)
        ctx.theme.registerStyle("personal-form-full-width", io.horion.cv.styles.PersonalFormFullWidthStyle)
        ctx.theme.registerStyle("form-label", io.horion.cv.styles.FormLabelStyle)
        ctx.theme.registerStyle("personal-details-form", io.horion.cv.styles.PersonalDetailsFormStyle)
        ctx.theme.registerStyle("form-input", io.horion.cv.styles.FormInputStyle)
        ctx.theme.registerStyle("personal-details-group-column", io.horion.cv.styles.PersonalDetailsGroupColumnStyle)
        ctx.theme.registerStyle("personal-details-row", io.horion.cv.styles.PersonalDetailsRowStyle)
        ctx.theme.registerStyle("personal-details-half-width", io.horion.cv.styles.PersonalDetailsHalfWidthStyle)
        ctx.theme.registerStyle("personal-details-full-width", io.horion.cv.styles.PersonalDetailsFullWidthStyle)
        ctx.theme.registerStyle("personal-details-photo", io.horion.cv.styles.PersonalDetailsPhotoStyle)
        ctx.theme.registerStyle("date-selector", io.horion.cv.styles.DateSelectorStyle)
        ctx.theme.registerStyle("dynamic-fields-container", io.horion.cv.styles.DynamicFieldsContainerStyle)
        ctx.theme.registerStyle("personal-details-main-row", io.horion.cv.styles.PersonalDetailsMainRowStyle)
        ctx.theme.registerStyle("personal-details-fields", io.horion.cv.styles.PersonalDetailsFieldsStyle)
        ctx.theme.registerStyle("personal-details-two-fields-row", io.horion.cv.styles.PersonalDetailsTwoFieldsRowStyle)
        ctx.theme.registerStyle("personal-details-fields-row", io.horion.cv.styles.PersonalDetailsFieldsRowStyle)
        ctx.theme.registerStyle("confirm-page-container", io.horion.cv.styles.ConfirmPageContainerStyle)
        ctx.theme.registerStyle("confirm-header-row", io.horion.cv.styles.ConfirmHeaderRowStyle)
        ctx.theme.registerStyle("confirm-back-icon", io.horion.cv.styles.ConfirmBackIconStyle)
        ctx.theme.registerStyle("confirm-title", io.horion.cv.styles.ConfirmTitleStyle)
        ctx.theme.registerStyle("confirm-content-wrapper", io.horion.cv.styles.ConfirmContentWrapperStyle)
        ctx.theme.registerStyle("confirm-form-section", io.horion.cv.styles.ConfirmFormSectionStyle)
        ctx.theme.registerStyle("confirm-form-label", io.horion.cv.styles.ConfirmFormLabelStyle)
        ctx.theme.registerStyle("confirm-operator-card", io.horion.cv.styles.ConfirmOperatorCardStyle)
        ctx.theme.registerStyle("confirm-orange-image", io.horion.cv.styles.ConfirmOrangeImageStyle)
        ctx.theme.registerStyle("confirm-mtn-image", io.horion.cv.styles.ConfirmMtnImageStyle)
        ctx.theme.registerStyle("confirm-phone-display-text", io.horion.cv.styles.ConfirmPhoneDisplayTextStyle)
        ctx.theme.registerStyle("confirm-button", io.horion.cv.styles.ConfirmButtonStyle)
        ctx.theme.registerStyle("topbar", io.horion.cv.styles.TopbarStyle)
        ctx.theme.registerStyle("branding", io.horion.cv.styles.BrandingStyle)
        ctx.theme.registerStyle("action-buttons-row", io.horion.cv.styles.ActionButtonsRowStyle)
        ctx.theme.registerStyle("dashboard-button", io.horion.cv.styles.DashboardButtonStyle)
        ctx.theme.registerStyle("create-cv-button", io.horion.cv.styles.CreateCvButtonStyle)
        ctx.theme.registerStyle("login-button", io.horion.cv.styles.LoginButtonStyle)
        ctx.theme.registerStyle("desktop-nav-container", io.horion.cv.styles.DesktopNavContainerStyle)
        ctx.theme.registerStyle("create-cv-button-text", io.horion.cv.styles.CreateCvButtonTextStyle)
        ctx.theme.registerStyle("login-button-text", io.horion.cv.styles.LoginButtonTextStyle)
        ctx.theme.registerStyle("theme-icon", io.horion.cv.styles.ThemeIconStyle)
        ctx.theme.registerStyle("mobile-menu-burger", io.horion.cv.styles.MobileMenuBurgerStyle)
        ctx.theme.registerStyle("nav-link", io.horion.cv.styles.NavLinkStyle)
        ctx.theme.registerStyle("footer-mobile-container", io.horion.cv.styles.FooterMobileContainerStyle)
        ctx.theme.registerStyle("footer-desktop-container", io.horion.cv.styles.FooterDesktopContainerStyle)
        ctx.theme.registerStyle("footer-link-gap", io.horion.cv.styles.FooterLinkGapStyle)
        ctx.theme.registerStyle("navigation-link", io.horion.cv.styles.NavigationLinkStyle)
        ctx.theme.registerStyle("cover-letter", io.horion.cv.styles.CoverLetterStyle)
        ctx.theme.registerStyle("view-more-button-stylecss", io.horion.cv.styles.ViewMoreButtonStylecss)
        ctx.theme.registerStyle("arrow-wrapper", io.horion.cv.styles.ArrowWrapperStyle)
        ctx.theme.registerStyle("arrow-image", io.horion.cv.styles.ArrowImageStyle)
        ctx.theme.registerStyle("cover-letter-section", io.horion.cv.styles.CoverLetterSectionStyle)
        ctx.theme.registerStyle("quality-field", io.horion.cv.styles.QualityFieldStyle)
        ctx.theme.registerStyle("form-card", io.horion.cv.styles.FormCardStyle)
        ctx.theme.registerStyle("generic-summary-row", io.horion.cv.styles.GenericSummaryRowStyle)
        ctx.theme.registerStyle("summary-title", io.horion.cv.styles.SummaryTitleStyle)
        ctx.theme.registerStyle("summary-subtitle", io.horion.cv.styles.SummarySubtitleStyle)
        ctx.theme.registerStyle("summary-default-text", io.horion.cv.styles.SummaryDefaultTextStyle)
        ctx.theme.registerStyle("edit-button-box", io.horion.cv.styles.EditButtonBoxStyle)
        ctx.theme.registerStyle("edit-button-icon", io.horion.cv.styles.EditButtonIconStyle)
        ctx.theme.registerStyle("accordion-container", io.horion.cv.styles.AccordionContainerStyle)
        ctx.theme.registerStyle("accordion-title", io.horion.cv.styles.AccordionTitleStyle)
        ctx.theme.registerStyle("accordion-action-button-box", io.horion.cv.styles.AccordionActionButtonBoxStyle)
        ctx.theme.registerStyle("accordion-arrow-icon", io.horion.cv.styles.AccordionArrowIconStyle)
        ctx.theme.registerStyle("accordion-plus-icon", io.horion.cv.styles.AccordionPlusIconStyle)
        ctx.theme.registerStyle("accordion-plus-icon-styles", io.horion.cv.styles.AccordionPlusIconStyles)
        ctx.theme.registerStyle("testimonial-image", io.horion.cv.styles.TestimonialImageStyle)
        ctx.theme.registerStyle("testimonial-section", io.horion.cv.styles.TestimonialSectionStyle)
        ctx.theme.registerStyle("testimonial-title", io.horion.cv.styles.TestimonialTitleStyle)
        ctx.theme.registerStyle("personalized-button", io.horion.cv.styles.PersonalizedButtonStyle)
        ctx.theme.registerStyle("personalized-icon", io.horion.cv.styles.PersonalizedIconStyle)
        ctx.theme.registerStyle("personalized-text", io.horion.cv.styles.PersonalizedTextStyle)
        ctx.theme.registerStyle("personalized-chevron", io.horion.cv.styles.PersonalizedChevronStyle)
        ctx.theme.registerStyle("dropdown-item", io.horion.cv.styles.DropdownItemStyle)
        ctx.theme.registerStyle("cover-button", io.horion.cv.styles.CoverButtonStyle)
        ctx.theme.registerStyle("hero-banner", io.horion.cv.styles.HeroBannerStyle)
        ctx.theme.registerStyle("hero-content-padding", io.horion.cv.styles.HeroContentPaddingStyle)
        ctx.theme.registerStyle("hero-text-column", io.horion.cv.styles.HeroTextColumnStyle)
        ctx.theme.registerStyle("hero-title-stylecss", io.horion.cv.styles.HeroTitleStylecss)
        ctx.theme.registerStyle("hero-subtitle-stylecss", io.horion.cv.styles.HeroSubtitleStylecss)
        ctx.theme.registerStyle("motive-button", io.horion.cv.styles.MotiveButtonStyle)
        ctx.theme.registerStyle("activity-full-width-field", io.horion.cv.styles.ActivityFullWidthFieldStyle)
        ctx.theme.registerStyle("activity-half-width-field", io.horion.cv.styles.ActivityHalfWidthFieldStyle)
        ctx.theme.registerStyle("formation-fields", io.horion.cv.styles.FormationFieldsStyle)
        ctx.theme.registerStyle("formation-field", io.horion.cv.styles.FormationFieldStyle)
        ctx.theme.registerStyle("activity-field", io.horion.cv.styles.ActivityFieldStyle)
        ctx.theme.registerStyle("activity-form", io.horion.cv.styles.ActivityFormStyle)
        ctx.theme.registerStyle("dropdown", io.horion.cv.styles.DropdownStyle)
        ctx.theme.registerStyle("competence-form", io.horion.cv.styles.CompetenceFormStyle)
        ctx.theme.registerStyle("competence-fields-row", io.horion.cv.styles.CompetenceFieldsRowStyle)
        ctx.theme.registerStyle("competence-equal-field", io.horion.cv.styles.CompetenceEqualFieldStyle)
        ctx.theme.registerStyle("competence-level-label", io.horion.cv.styles.CompetenceLevelLabelStyle)
        ctx.theme.registerStyle("course-form", io.horion.cv.styles.CourseFormStyle)
        ctx.theme.registerStyle("course-fields-row", io.horion.cv.styles.CourseFieldsRowStyle)
        ctx.theme.registerStyle("course-equal-field", io.horion.cv.styles.CourseEqualFieldStyle)
        ctx.theme.registerStyle("certificate-form", io.horion.cv.styles.CertificateFormStyle)
        ctx.theme.registerStyle("certificate-fields-row", io.horion.cv.styles.CertificateFieldsRowStyle)
        ctx.theme.registerStyle("certificate-equal-field", io.horion.cv.styles.CertificateEqualFieldStyle)
        ctx.theme.registerStyle("toolbar-icon-container", io.horion.cv.styles.ToolbarIconContainerStyle)
        ctx.theme.registerStyle("toolbar-icon-inner", io.horion.cv.styles.ToolbarIconInnerStyle)
        ctx.theme.registerStyle("text-editor-separator", io.horion.cv.styles.TextEditorSeparatorStyle)
        ctx.theme.registerStyle("text-editor-toolbar-row", io.horion.cv.styles.TextEditorToolbarRowStyle)
        ctx.theme.registerStyle("vertical-divider", io.horion.cv.styles.VerticalDividerStyle)
        ctx.theme.registerStyle("alignment-option-icon", io.horion.cv.styles.AlignmentOptionIconStyle)
        ctx.theme.registerStyle("competence-form-container", io.horion.cv.styles.CompetenceFormContainerStyle)
        ctx.theme.registerStyle("competence-field", io.horion.cv.styles.CompetenceFieldStyle)
        ctx.theme.registerStyle("competence-label-text", io.horion.cv.styles.CompetenceLabelTextStyle)
        ctx.theme.registerStyle("competence-range-input", io.horion.cv.styles.CompetenceRangeInputStyle)
        ctx.theme.registerStyle("competence-value-text", io.horion.cv.styles.CompetenceValueTextStyle)
        ctx.theme.registerStyle("success-container", io.horion.cv.styles.SuccessContainerStyle)
        ctx.theme.registerStyle("success-title", io.horion.cv.styles.SuccessTitleStyle)
        ctx.theme.registerStyle("success-subtitle", io.horion.cv.styles.SuccessSubtitleStyle)
        ctx.theme.registerStyle("success-card-container", io.horion.cv.styles.SuccessCardContainerStyle)
        ctx.theme.registerStyle("success-card-title", io.horion.cv.styles.SuccessCardTitleStyle)
        ctx.theme.registerStyle("success-action-button", io.horion.cv.styles.SuccessActionButtonStyle)
        ctx.theme.registerStyle("success-secondary-button", io.horion.cv.styles.SuccessSecondaryButtonStyle)
        ctx.theme.registerStyle("success-icon", io.horion.cv.styles.SuccessIconStyle)
        ctx.theme.registerStyle("transaction-row-padding", io.horion.cv.styles.TransactionRowPaddingStyle)
        ctx.theme.registerStyle("transaction-text-responsive", io.horion.cv.styles.TransactionTextResponsiveStyle)
        ctx.theme.registerStyle("transaction-date-gap", io.horion.cv.styles.TransactionDateGapStyle)
        ctx.theme.registerStyle("transaction-payment-mode-gap", io.horion.cv.styles.TransactionPaymentModeGapStyle)
        ctx.theme.registerStyle("transaction-phone-text", io.horion.cv.styles.TransactionPhoneTextStyle)
        ctx.theme.registerStyle("transaction-provider-image", io.horion.cv.styles.TransactionProviderImageStyle)
        ctx.theme.registerStyle("cv-preview-page", io.horion.cv.styles.CvPreviewPageStyle)
        ctx.theme.registerStyle("cv-preview-topbar", io.horion.cv.styles.CvPreviewTopbarStyle)
        ctx.theme.registerStyle("cv-preview-main-content", io.horion.cv.styles.CvPreviewMainContentStyle)
        ctx.theme.registerStyle("cv-preview-canvas-container", io.horion.cv.styles.CvPreviewCanvasContainerStyle)
        ctx.theme.registerStyle("cv-preview-actions", io.horion.cv.styles.CvPreviewActionsStyle)
        ctx.theme.registerStyle("cv-preview-modify-button", io.horion.cv.styles.CvPreviewModifyButtonStyle)
        ctx.theme.registerStyle("cv-preview-download-button", io.horion.cv.styles.CvPreviewDownloadButtonStyle)
        ctx.theme.registerStyle("cv-preview-action-icon", io.horion.cv.styles.CvPreviewActionIconStyle)
        ctx.theme.registerStyle("cv-preview-back-button", io.horion.cv.styles.CvPreviewBackButtonStyle)
        ctx.theme.registerStyle("cv-preview-title", io.horion.cv.styles.CvPreviewTitleStyle)
        ctx.theme.registerStyle("cv-preview-header-icon", io.horion.cv.styles.CvPreviewHeaderIconStyle)
        ctx.theme.registerStyle("cv-preview-theme-group", io.horion.cv.styles.CvPreviewThemeGroupStyle)
        ctx.theme.registerStyle("cv-preview-theme-icon", io.horion.cv.styles.CvPreviewThemeIconStyle)
        ctx.theme.registerStyle("accordion-content", io.horion.cv.styles.AccordionContentStyle)
        ctx.theme.registerStyle("form-content", io.horion.cv.styles.FormContentStyle)
        ctx.theme.registerStyle("form-section-content", io.horion.cv.styles.FormSectionContentStyle)
        ctx.theme.registerStyle("form-action-section", io.horion.cv.styles.FormActionSectionStyle)
        ctx.theme.registerStyle("extra-sections-grid", io.horion.cv.styles.ExtraSectionsGridStyle)
        ctx.theme.registerStyle("delete-button", io.horion.cv.styles.DeleteButtonStyle)
        ctx.theme.registerStyle("delete-button-icon", io.horion.cv.styles.DeleteButtonIconStyle)
        ctx.theme.registerStyle("complete-button", io.horion.cv.styles.CompleteButtonStyle)
        ctx.theme.registerStyle("complete-button-icon", io.horion.cv.styles.CompleteButtonIconStyle)
        ctx.theme.registerStyle("complete-button-text", io.horion.cv.styles.CompleteButtonTextStyle)
        ctx.theme.registerStyle("reference-form-container", io.horion.cv.styles.ReferenceFormContainerStyle)
        ctx.theme.registerStyle("reference-full-width-field", io.horion.cv.styles.ReferenceFullWidthFieldStyle)
        ctx.theme.registerStyle("reference-fields-row", io.horion.cv.styles.ReferenceFieldsRowStyle)
        ctx.theme.registerStyle("reference-half-width-field", io.horion.cv.styles.ReferenceHalfWidthFieldStyle)
        ctx.theme.registerStyle("arrow-white-image", io.horion.cv.styles.ArrowWhiteImageStyle)
        ctx.theme.registerStyle("country-button", io.horion.cv.styles.CountryButtonStyle)
        ctx.theme.registerStyle("country-section-container", io.horion.cv.styles.CountrySectionContainerStyle)
        ctx.theme.registerStyle("country-title-mobile", io.horion.cv.styles.CountryTitleMobileStyle)
        ctx.theme.registerStyle("country-title-desktop", io.horion.cv.styles.CountryTitleDesktopStyle)
        ctx.theme.registerStyle("country-description-text", io.horion.cv.styles.CountryDescriptionTextStyle)
        ctx.theme.registerStyle("country-descriptionsub-text", io.horion.cv.styles.CountryDescriptionsubTextStyle)
        ctx.theme.registerStyle("country-cards-row", io.horion.cv.styles.CountryCardsRowStyle)
        ctx.theme.registerStyle("country-button-responsive", io.horion.cv.styles.CountryButtonResponsiveStyle)
        ctx.theme.registerStyle("country-button-arrow", io.horion.cv.styles.CountryButtonArrowStyle)
        ctx.theme.registerStyle("info-letter-main-layout-container", io.horion.cv.styles.InfoLetterMainLayoutContainerStyle)
        ctx.theme.registerStyle("info-letter-form-scroll-container", io.horion.cv.styles.InfoLetterFormScrollContainerStyle)
        ctx.theme.registerStyle("info-letter-divider", io.horion.cv.styles.InfoLetterDividerStyle)
        ctx.theme.registerStyle("info-letter-preview-container", io.horion.cv.styles.InfoLetterPreviewContainerStyle)
        ctx.theme.registerStyle("info-main-layout-container", io.horion.cv.styles.InfoMainLayoutContainerStyle)
        ctx.theme.registerStyle("info-form-scroll-container", io.horion.cv.styles.InfoFormScrollContainerStyle)
        ctx.theme.registerStyle("info-divider", io.horion.cv.styles.InfoDividerStyle)
        ctx.theme.registerStyle("info-preview-container", io.horion.cv.styles.InfoPreviewContainerStyle)
        ctx.theme.registerStyle("navigation-bar-container", io.horion.cv.styles.NavigationBarContainerStyle)
        ctx.theme.registerStyle("nav-title-text", io.horion.cv.styles.NavTitleTextStyle)
        ctx.theme.registerStyle("hide-on-mobile", io.horion.cv.styles.HideOnMobileStyle)
        ctx.theme.registerStyle("download-mobile-only", io.horion.cv.styles.downloadMobileOnlyStyle)
        ctx.theme.registerStyle("desktop-only-stylecss", io.horion.cv.styles.DesktopOnlyStylecss)
        ctx.theme.registerStyle("download-desktop-only", io.horion.cv.styles.downloadDesktopOnlyStyle)
        ctx.theme.registerStyle("mobile-only-stylecss", io.horion.cv.styles.MobileOnlyStylecss)
        ctx.theme.registerStyle("show-only-on-mobile", io.horion.cv.styles.ShowOnlyOnMobileStyle)
        ctx.theme.registerStyle("re-accordion-row-container", io.horion.cv.styles.ReAccordionRowContainerStyle)
        ctx.theme.registerStyle("accordion-content-padding", io.horion.cv.styles.AccordionContentPaddingStyle)
        ctx.theme.registerStyle("telecharger-row", io.horion.cv.styles.TelechargerRowStyle)
        ctx.theme.registerStyle("telecharger-button", io.horion.cv.styles.TelechargerButtonStyle)
        ctx.theme.registerStyle("re-accordion-section-padding", io.horion.cv.styles.ReAccordionSectionPaddingStyle)
        ctx.theme.registerStyle("re-accordion-row-content", io.horion.cv.styles.ReAccordionRowContentStyle)
        ctx.theme.registerStyle("re-accordion-title-text", io.horion.cv.styles.ReAccordionTitleTextStyle)
        ctx.theme.registerStyle("re-accordion-action-position", io.horion.cv.styles.ReAccordionActionPositionStyle)
        ctx.theme.registerStyle("re-accordion-action-box", io.horion.cv.styles.ReAccordionActionBoxStyle)
        ctx.theme.registerStyle("re-accordion-action-icon", io.horion.cv.styles.ReAccordionActionIconStyle)
        ctx.theme.registerStyle("re-accordion-plus-icon-styles", io.horion.cv.styles.ReAccordionPlusIconStyles)
        ctx.theme.registerStyle("re-accordion-plus-icon", io.horion.cv.styles.ReAccordionPlusIconStyle)
        ctx.theme.registerStyle("dropdown-trigger", io.horion.cv.styles.DropdownTriggerStyle)
        ctx.theme.registerStyle("dropdown-trigger-icon", io.horion.cv.styles.DropdownTriggerIconStyle)
        ctx.theme.registerStyle("headbar-container", io.horion.cv.styles.HeadbarContainerStyle)
        ctx.theme.registerStyle("headbar-back-button", io.horion.cv.styles.HeadbarBackButtonStyle)
        ctx.theme.registerStyle("headbar-icon-size", io.horion.cv.styles.HeadbarIconSizeStyle)
        ctx.theme.registerStyle("headbar-text-size", io.horion.cv.styles.HeadbarTextSizeStyle)
        ctx.theme.registerStyle("headbar-title-group", io.horion.cv.styles.HeadbarTitleGroupStyle)
        ctx.theme.registerStyle("headbar-download-wrapper", io.horion.cv.styles.HeadbarDownloadWrapperStyle)
        ctx.theme.registerStyle("headbar-theme-toggle-group", io.horion.cv.styles.HeadbarThemeToggleGroupStyle)
        ctx.theme.registerStyle("headbar-theme-icon-size", io.horion.cv.styles.HeadbarThemeIconSizeStyle)
        ctx.theme.registerStyle("headbar-title", io.horion.cv.styles.HeadbarTitleStyle)
        ctx.theme.registerStyle("headbar-title-input", io.horion.cv.styles.HeadbarTitleInputStyle)
        ctx.theme.registerKeyframes("spin", io.horion.cv.components.SpinKeyframes)
        io.horion.cv.initStyles(ctx)
    }

    // Dedup any leading slashes after removing the origin, just in case someone typed
    // something like `https://site.com//about` by accident. If we pass `//about` into
    // `tryRoutingTo`, Kobweb will reject it as a protocol-relative URL; instead, we
    // want it to navigate to `/about`
    router.tryRoutingTo(BasePath.remove("/" + window.location.href.removePrefix(window.origin).trimStart('/')), UpdateHistoryMode.REPLACE)

    // For SEO, we may bake the contents of a page in at build time. However, we will
    // overwrite them the first time we render this page with their composable, dynamic
    // versions. Think of this as poor man's hydration :)
    // See also: https://en.wikipedia.org/wiki/Hydration_(web_development)
    val root = document.getElementById("_kobweb-root")!!
    while (root.firstChild != null) { root.removeChild(root.firstChild!!) }

    renderComposable(rootElementId = "_kobweb-root") {
        io.horion.cv.AppEntry {
            router.renderActivePage { DeferringHost { it() } }
        }
    }
}
